var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2892FB60-01F6-44CB-9063-7CF90EAF2244") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Requirement-Popup",
    transform: "translate(-1214.000000, -194.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(208.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close-button",
    transform: "translate(1008.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#83858C",
    strokeWidth: 2,
    fill: "#3E424D",
    cx: 16,
    cy: 16,
    r: 17
  }), /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(15.578947, 16.000000) rotate(-315.000000) translate(-15.578947, -16.000000) translate(8.000000, 8.000000)",
    stroke: "#FFFFFF",
    strokeLinecap: "square",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7.57894737,
    y1: 0.421052632,
    x2: 7.57894737,
    y2: 15.5789474,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.1578947,
    y1: 8,
    x2: 0,
    y2: 8,
    id: "Line"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.44b06c79f333a39d58cebac1694528c6.svg";
export { ForwardRef as ReactComponent };